export const getText = (language) => {
    if (language === "US") {
        return text.US
    } else {
        return text.ZH
    }
}

const text = {
    ZH: {
        home: {
            header: "上海朴迪企业管理咨询有限公司 (PPC)",
            sentence_1: "是一家通过ISO9001认证的专业从事为汽车制造工业提供第三方检验的服务性公司",
            section1_header: "关于我们",
            section1_text: "上海朴迪企业管理咨询有限公司（PPC）是一家通过ISO9001认证的专业从事为汽车制造工业提供第三方检验的服务性公司. 如果零部件供应商被证实缺乏质量控制能力或产品检验无效, 即由第三方服务公司对所有产品进行发货前的检验",
            section1_text2: "涉及的产品范围包括: 汽车底盘系统，汽车外饰件，汽车内饰件，汽车电器，车身和汽车动力系统.",
            section2_header: "我们的团队",
            section2_text: "公司由来自不同零部件事业部的质量工程师和专业的检验人员组成。专业的团队成员包括: ",
            section2_text1: "CQE - 美国质量协会ASQ注册的质量工程师",
            section2_text2: "PMP - 美国项目管理协会PMI注册的项目管理经理",
            section2_text3: "P.Eng - 加拿大专业工程师协会注册工程师",
            section2_text4: "SQE - 通用汽车供应商质量工程师培训证书",
            section3_header: "服务领域",
            section3_text1: "朴迪咨询由三大业务组成:",
            section3_text2: "产品及零部件检验（包括过程检验，控制发货检验CS1,CS2,GP12 ，分选检验等）",
            section3_text3: "质量咨询及培训服务",
            section3_text5: "驻厂代表",
            section3_text4: "朴迪咨询作为公正的第三方能为客户提供一周7天，1天24小时的检验服务。朴迪承诺在接到客户的检验需求后24小时内到达客户的指定的现场并开始检验工作。",
            section4_header: "业务宗旨", 
            section4_text1: "我们集聚众多业务精英。凭借企业自身的实力和经验，朴迪将不断创新来满足客户的新需求。旨在通过我们的服务，帮助客户提升产品的价值:",
            section4_text2: "以客户为中心",
            section4_text3: "专业的服务团队",
            section4_text4: "严格的管理",
            section5_header: "服务区域",
        },
        header: {
            section_1: "首页",
            section_2: "检验流程",
            section_3: "工作实例",
            section_4: "联系我们"
        },
        inspection_page: {
            header: "检验流程",
            header_2: "二级控制检验 (CS2) 的流程",
            process_flow_diagram: [
                {
                    title: "Supplier Inspection",
                    description: "供应商CS1/GP12检验",
                },
                {
                    title: "Shipment",
                    description: "供应商把自检合格品发送到PPC的待检区",
                },
                {
                    title: "Inspection",
                    description: "PPC进行控制发货检验",
                },
                {
                    title: "Recording",
                    description: "记录检验成果",
                },
                {
                    title: "Packaging",
                    description: "检验后成品包装",
                },
                {
                    title: "Labelling",
                    description: "标示和标贴",
                },
                {
                    title: "Conclusion",
                    description: "发送",
                },
            ],
            subheader_2: {
                header: "如何退出第三方控制发货检验?",
                bullet_1: "供应商至少20天内没有在第三方检验的过程中发现不合格品",
                bullet_2: "所有有疑问的库存产品都已被验证",
                bullet_3: "供应商找到了发生问题的真正根源",
                bullet_4: "对各项不符合项目进行了适当的防范措施",
                bullet_5: "实施并验证了有效的不可逆纠正行为"
            }
        },
        project_page: {
            header: "工作实例",
            sample_instruction: "指导书样例"
        },
        contact_page: {
            header: "联系我们",
            section_1: "通常",
            section_2: "地址",
            mobile: "电话",
            fax: "传真",
            email: "邮件",
            address1: "上海市浦东新区沪南路2419弄30号403室 (万科活力城B座) 邮编 201204",
            mobile_num: "(021) 6160-0958",
            phone: "(021) 6160-0959",
            address: "公司地址",
        }
    },

    US: {
        home: {
            header: "Shanghai Post Production Consulting Co. Ltd",
            sentence_1: "We provide containment, inspection, and training for the automotive industry", 
            section1_header: "About Us",
            section1_text: "Shanghai Post Production Consulting Co. Ltd is an ISO 9001 certified professional third party provider. In cases where the supplier has a demonstrated lack of process control or ineffective containment, it's customers may escalate their shipping status to Controlled Shipping Level 2 (CS2). This results in a third party provider being invited to conduct an inspection before shipping.",
            section1_text2: "The range of products which PPC can cover include: chassis systems, exterior parts, interior parts, auto electronics, and automotive body/powertrain.",
            section2_header: "Our Team",
            section2_text: "We are a team of professional employees composed of quality engineers and inspection technicians. Every team member has multiple years of experience working in different auto divisions. Our team qualifications include:",
            section2_text1: "CQE - Certified by ASQ",
            section2_text2: "PMP - Certified by PMI",
            section2_text3: "P.Eng. - Certified by Professional Engineers Ontario",
            section2_text4: "SQE - Trained by General Motors",
            section3_header: "Our Services",
            section3_text1: "PPC focuses on three major businesses:",
            section3_text2: "Product Inspection (e.g. process inspection, final inspection, controlled shipping level 1 & 2, GP12, sorting, and inspection)",
            section3_text3: "Consulting and Training Services",
            section3_text5: "Resident Representatives",
            section3_text4: "PPC is available for inspection services 24/7. We guarantee to reach the designated work site and begin inspection within 24 hours of receiving the inspection requirements.",
            section4_header: "Mission Statement", 
            section4_text1: "Our mission is to meet and exceed all customer expectations by: ",
            section4_text2: "Putting customers first",
            section4_text3: "Having a talented team",
            section4_text4: "World-class management",
            section5_header: "Service Area",
        },
        header: {
            section_1: "Home",
            section_2: "Inspection Flow",
            section_3: "Past Projects",
            section_4: "Contact Us"
        },
        inspection_page: {
            header: "Inspection Flow",
            header_2: "CS2 Process Flow Diagram",
            process_flow_diagram: [
                {
                    title: "Supplier Inspection",
                    description: "Supplier performs CS1/GP12 inspection on all parts",
                },
                {
                    title: "Shipment",
                    description: "All parts are shipped to PPC's waiting area to prepare for inspection",
                },
                {
                    title: "Inspection",
                    description: "PPC performs CS2 Containment Inspection on all parts",
                },
                {
                    title: "Recording",
                    description: "All inspection results are swiftly and accurately recorded",
                },
                {
                    title: "Packaging",
                    description: "All parts are carefully packaged",
                },
                {
                    title: "Labelling",
                    description: "All parts are labelled",
                },
                {
                    title: "Conclusion",
                    description: "All parts are sent to the destination logistic warehouse",
                },
            ],
            subheader_2: {
                header: "CS2 Exit Conditions",
                bullet_1: "No listed defect(s) or reject(s) found in 3rd Part containment inspection for a minimum of 20 days",
                bullet_2: "All inventory was thoroughly inspected and verified",
                bullet_3: "Identified root causes for any problems that arise",
                bullet_4: "Implemented corrective, preventive, and error proof actions for any listed defects",
                bullet_5: "Implemented and validated an irreversible corrective action"
            }
        },
        project_page: {
            header: "Past Projects",
            sample_instruction: "Sample Instructions"
        },
        contact_page: {
            header: "Contact Us",
            section_1: "General",
            section_2: "Address",
            mobile: "Phone",
            fax: "Fax",
            email: "Email",
            address1: "2419 Hunan Rd, Wolcity Plaza Building B #403",
            address2: "Shanghai, China, 201204",
            mobile_num: "+86 21-6160-0958",
            phone: "+86 21-6160-0959",
            address: "Address"
        }
    }  
}

export default text;
